import { PayloadAction } from "@reduxjs/toolkit";
import { Message } from "../../../../utl/models/Message";
import { EmployeesState } from "../models/EmployeesState";

const setMessage = (state: EmployeesState, action: PayloadAction<Message>) => {
    state.message = action.payload.message;
}

export default setMessage;